import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { SharedModule } from '../../shared.module';
@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() pdfSrc: string | any;
  @Input() pageChangeDuration: number = 5; // Duration in seconds for auto page change
  page: number = 1;
  totalPages: number = 0;
  zoomLevel: number = 0.2;
  pdf: PDFDocumentProxy;
  private pageChangeInterval: any;
  isTransitioning: boolean = false;
  slideDirection: 'next' | 'prev' = 'next';
  
  constructor() { }
ngOnChanges(changes: SimpleChanges): void {
  console.log(changes);
  if (changes['pdfSrc']) {
    this.stopAutoPageChange();
    this.page = 1;
  }
}
  ngOnInit() {
  }
  
  onPdfLoaded(pdf: PDFDocumentProxy): void {
    this.pdf = pdf;
    this.totalPages = pdf.numPages; // Get the total number of pages in the PDF
    this.startAutoPageChange();
  }
  
  startAutoPageChange(): void {
    this.stopAutoPageChange();
    
    if (this.pageChangeDuration && this.pageChangeDuration > 0 && this.totalPages > 1) {
      this.pageChangeInterval = setInterval(() => {
        this.nextPage();
      }, this.pageChangeDuration * 1000);
    }
  }
  
  nextPage(): void {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.slideDirection = 'next';
    
    // Change page immediately, animation will handle the visual transition
    this.page++;
    if (this.page > this.totalPages) {
      this.page = 1;
    }
    
    // Reset transition state after animation completes
    setTimeout(() => {
      this.isTransitioning = false;
    }, 500);
  }
  
  prevPage(): void {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.slideDirection = 'prev';
    
    // Change page immediately, animation will handle the visual transition
    this.page--;
    if (this.page < 1) {
      this.page = this.totalPages;
    }
    
    // Reset transition state after animation completes
    setTimeout(() => {
      this.isTransitioning = false;
    }, 500);
  }
  
  stopAutoPageChange(): void {
    if (this.pageChangeInterval) {
      clearInterval(this.pageChangeInterval);
      this.pageChangeInterval = null;
    }
  }
  
  ngOnDestroy(): void {
    this.stopAutoPageChange();
  }
  
  onSave() {
    window.open(this.pdfSrc, '_blank')
  }
}

